import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useCallback } from 'react';
import { IconArrowLeftOutline, IconArrowRightOutline } from '@circlefin/euclid-icons/common';
import classNames from 'classnames';
import { Button } from '../Button/Button.es.js';
import { CarouselIndicators } from './Carousel.Indicators/Carousel.Indicators.es.js';
import { CarouselStep } from './Carousel.Step/Carousel.Step.es.js';

const Carousel = ({ variant = 'default', children, onBack, onNext })=>{
    const [stepIndex, setStepIndex] = useState(0);
    const childrenArray = Array.isArray(children) ? children : [
        children
    ];
    const steps = childrenArray.filter((step)=>step.props.inactive !== true);
    const lastStepIndex = steps.length - 1;
    const handleBack = useCallback((e)=>{
        setStepIndex((curr)=>curr - 1);
        onBack?.(e);
    }, [
        onBack
    ]);
    const handleNext = useCallback((e)=>{
        setStepIndex((curr)=>curr + 1);
        onNext?.(e);
    }, [
        onNext
    ]);
    return jsxs("div", {
        className: classNames('cb-carousel', variant),
        children: [
            jsx("div", {
                className: "nav-container left",
                children: jsx(Button, {
                    className: classNames('nav-button', {
                        invisible: stepIndex === 0
                    }),
                    "data-testid": "carousel-back",
                    onClick: handleBack,
                    size: "lg",
                    variant: "secondary",
                    children: jsx(IconArrowLeftOutline, {
                        size: 16
                    })
                })
            }),
            steps[stepIndex],
            jsx(CarouselIndicators, {
                activeStep: stepIndex,
                className: "mb-2",
                onStepClick: setStepIndex,
                steps: steps.length
            }),
            jsx("div", {
                className: "nav-container right",
                children: jsx(Button, {
                    className: classNames('nav-button', {
                        invisible: stepIndex === lastStepIndex
                    }),
                    "data-testid": "carousel-next",
                    onClick: handleNext,
                    size: "lg",
                    variant: "secondary",
                    children: jsx(IconArrowRightOutline, {
                        size: 16
                    })
                })
            })
        ]
    });
};
Carousel.displayName = 'Carousel';
Carousel.Step = CarouselStep;
Carousel.Indicators = CarouselIndicators;

export { Carousel, Carousel as default };
//# sourceMappingURL=Carousel.es.js.map
